module.exports = __webpack_public_path__ + "assets/img/develop.3710a4ab.png";